import React from 'react';
import styled from 'styled-components';

import { Typography } from '@material-ui/core/';

import CountUp from 'react-countup';

import IconSolarEnergy from '../../../assets/icon-solar-energy.svg';

const Root = styled.div`
	padding: 0 20px;

	h6 {
		margin-top: 20px;
		font-size: 20px;
		font-weight: bold;
		text-transform: uppercase;
	}

	p {
		margin-top: 20px;
		font-size: 14px;
	}

	.image-block {
		display: flex;

		img {
			width: 70px;
			margin: 0 40px;
		}
	}
`;

const ContentSolarEnergy = ({ kwPeak }) => (
	<Root>
		<Typography variant="h6">Eigenverbrauch optimieren</Typography>
		<Typography>
			Strom aus der Sonne ist unglaublich attraktiv, denn er ist kostenlos. Leider
			ist er nicht immer rund um die Uhr verfügbar. Und wenn doch, dann kann es
			sein, das man ihn in dem Moment gar nicht nutzen kann. Zudem wird die
			Einspeisung ins Netz finanziell auch immer unattraktiver.
		</Typography>
		<Typography>
			Ein Batteriespeicher bringt hier die Lösung: Denn er kann überschüssigen Strom
			speichern, um ihn jederzeit nutzen zu können, wenn er gebraucht wird.
		</Typography>
		<div className="image-block">
			<img src={IconSolarEnergy} alt="Solarenergie" />
			<div className="text-block">
				<Typography>
					<strong>Photovoltaik(PV)-Anlage</strong>
				</Typography>
				<Typography>
					Zur Bestimmung Ihrer persönlichen PV-Anlage wird die passende Größe
					(kW-Peak), im Bereich zwischen 30 kW-Peak und 750 kW-Peak, ermittelt.
					Als Grundlage dieser ersten Auslegung wird Ihr persönliches
					Verbrauchsprofil sowie Ihr Strombezugspreis verwendet.
				</Typography>
				<Typography>
					<strong>
						Unsere Empfehlung:{' '}
						<CountUp
							start={0}
							end={kwPeak}
							duration={2.75}
							separator="."
							decimals={2}
							decimal=","
							suffix=" kW-Peak"
						/>
					</strong>
				</Typography>
			</div>
		</div>
	</Root>
);

export default ContentSolarEnergy;
